/*
 * PUNCH PRODUCT CARD — AUTO-LOAD HOVER FIX
 *
 * Additive fallback ONLY for product cards inserted after initial page load.
 * It does not alter:
 * - initial product cards
 * - blend/background image rendering
 * - image opacity/filter
 * - Swatch King
 * - whole-card click script
 * - Liquid/CSS
 *
 * Behaviour:
 * Desktop/fine-pointer only:
 *   mouse enters image area -> scroll native slider to image 2
 *   mouse leaves image area -> scroll native slider back to image 1
 */

(() => {
  'use strict';

  const CARD_SELECTOR =
    'body.template-collection .product-list article.punch-product-card';

  const MEDIA_SELECTOR = '.punch-product-card__media-inner';
  const SLIDER_SELECTOR = '.punch-product-card__slider';

  /* Everything already on the page is deliberately left untouched. */
  const initialCards = new WeakSet(
    Array.from(document.querySelectorAll(CARD_SELECTOR))
  );

  function isDesktopHover() {
    return window.matchMedia(
      '(min-width: 768px) and (hover: hover) and (pointer: fine)'
    ).matches;
  }

  function bindAutoLoadedCard(card) {
    if (!(card instanceof Element)) return;
    if (!card.matches(CARD_SELECTOR)) return;
    if (initialCards.has(card)) return;
    if (card.dataset.punchAutoHoverBound === 'true') return;

    const media = card.querySelector(MEDIA_SELECTOR);
    const slider = card.querySelector(SLIDER_SELECTOR);

    if (!media || !slider) return;

    card.dataset.punchAutoHoverBound = 'true';

    media.addEventListener('mouseenter', () => {
      if (!isDesktopHover()) return;
      if (slider.children.length < 2) return;

      const width = slider.clientWidth;
      if (!width) return;

      slider.scrollTo({
        left: width,
        behavior: 'smooth'
      });
    });

    media.addEventListener('mouseleave', () => {
      if (!isDesktopHover()) return;

      slider.scrollTo({
        left: 0,
        behavior: 'smooth'
      });
    });
  }

  function inspectAddedNode(node) {
    if (!(node instanceof Element)) return;

    if (node.matches(CARD_SELECTOR)) {
      bindAutoLoadedCard(node);
    }

    node.querySelectorAll?.(CARD_SELECTOR).forEach(bindAutoLoadedCard);
  }

  function start() {
    const target =
      document.querySelector('.product-list') ||
      document.querySelector('main#main') ||
      document.querySelector('main');

    if (!target) return;

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          inspectAddedNode(node);
        }
      }
    });

    observer.observe(target, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

